import { Tabs, Tab } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useEffect, useState, ReactNode } from 'react'

import { Payment, PaymentNovelty } from '../../types'
import { modalTabs } from '../../theme/custom-styles'

type TabPanelProps = {
  dir?: string
  index: number
  value: number
  maxHeight?: string
  children?: ReactNode
}

export const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, maxHeight, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      style={{ maxHeight: maxHeight || '200px', width: '100%', overflowY: 'auto' }}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  )
}

export const BackgroundResearchNoveltyForm = ({ paymentData }: { paymentData: Payment | Partial<Payment> | null }) => {
  const { t } = useTranslation(['payments-to-review-management', 'common'])

  const [selectedResultsTab, setSelectedResultsTab] = useState(0)
  const [backgroundResearchData, setBackgroundResearchData] = useState<{
    riskLevel: number
    noveltiesByNameCount: number
    noveltiesByDocumentNumberCount: number
    backgroundResearhNoveltiesByName: Array<any>
    backgroundResearhNoveltiesByDocumentNumber: Array<any>
  }>({ riskLevel: 0, noveltiesByNameCount: 0, noveltiesByDocumentNumberCount: 0, backgroundResearhNoveltiesByName: [], backgroundResearhNoveltiesByDocumentNumber: [] })

  const handleChange = (_: unknown, selectedTabId: number) => {
    setSelectedResultsTab(selectedTabId)
  }

  const tabProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    }
  }

  useEffect(() => {
    if (paymentData) {
      const backgroundResearchNovelty = paymentData.novelties?.find((paymentNovelty: PaymentNovelty | Partial<PaymentNovelty>) => paymentNovelty.type === 'background-research')

      if (backgroundResearchNovelty) {
        const riskLevel =
          Number(backgroundResearchNovelty.backgroundResearchRiskLevelByDocumentNumber) > Number(backgroundResearchNovelty.backgroundResearchRiskLevelByName)
            ? Number(backgroundResearchNovelty.backgroundResearchRiskLevelByDocumentNumber)
            : Number(backgroundResearchNovelty.backgroundResearchRiskLevelByDocumentNumber) < Number(backgroundResearchNovelty.backgroundResearchRiskLevelByName)
            ? Number(backgroundResearchNovelty.backgroundResearchRiskLevelByName)
            : Number(backgroundResearchNovelty.backgroundResearchRiskLevelByDocumentNumber) === Number(backgroundResearchNovelty.backgroundResearchRiskLevelByName) &&
              Number(backgroundResearchNovelty.backgroundResearchRiskLevelByDocumentNumber)

        setBackgroundResearchData({
          riskLevel: Number(riskLevel),
          backgroundResearhNoveltiesByName: backgroundResearchNovelty.backgroundResearhNoveltiesByName ? backgroundResearchNovelty.backgroundResearhNoveltiesByName : [],
          noveltiesByNameCount: backgroundResearchNovelty.backgroundResearhNoveltiesByName ? backgroundResearchNovelty.backgroundResearhNoveltiesByName.length : 0,
          noveltiesByDocumentNumberCount: backgroundResearchNovelty.backgroundResearhNoveltiesByDocumentNumber ? backgroundResearchNovelty.backgroundResearhNoveltiesByDocumentNumber.length : 0,
          backgroundResearhNoveltiesByDocumentNumber: backgroundResearchNovelty.backgroundResearhNoveltiesByDocumentNumber ? backgroundResearchNovelty.backgroundResearhNoveltiesByDocumentNumber : []
        })
      }
    }
  }, [paymentData])

  return (
    <div className="novelty-form-container">
      <div className="main-instruction">{t('resolveNoveltyModal.backgroundResearch.mainInstruction')}</div>
      <div className="background-research-novelty-form-container">
        <div
          style={{ flexDirection: 'column' }}
          className="background-research-data-container"
        >
          <div className="background-research-risk-data-container">
            <div className="background-research-bar-container">
              <div
                className="background-research-bar-fill"
                style={{
                  width: `${backgroundResearchData.riskLevel >= 1 && backgroundResearchData.riskLevel <= 4 ? 100 : backgroundResearchData.riskLevel >= 5 && backgroundResearchData.riskLevel <= 6 ? 50 : 0}%`,
                  backgroundColor:
                    backgroundResearchData.riskLevel >= 1 && backgroundResearchData.riskLevel <= 4 ? '#EF4444' : backgroundResearchData.riskLevel >= 5 && backgroundResearchData.riskLevel <= 6 ? '#F59E0B' : '#22C55E'
                }}
              ></div>
            </div>
            <div className="background-research-risk-text">{`${t('noveltiesTable.riskLevel')}: ${
              backgroundResearchData.riskLevel >= 1 && backgroundResearchData.riskLevel <= 4
                ? t('noveltiesTable.high')
                : backgroundResearchData.riskLevel >= 5 && backgroundResearchData.riskLevel <= 6
                ? t('noveltiesTable.medium')
                : t('noveltiesTable.low')
            }`}</div>
          </div>
          <Tabs
            centered
            sx={modalTabs}
            variant="fullWidth"
            onChange={handleChange}
            value={selectedResultsTab}
            aria-label="basic tabs example"
            TabIndicatorProps={{
              sx: {
                backgroundColor: 'rgb(46, 211, 183)'
              }
            }}
          >
            <Tab
              label={`${t('resolveNoveltyModal.backgroundResearch.resultsById')} (${backgroundResearchData.noveltiesByDocumentNumberCount})`}
              {...tabProps(0)}
            />
            <Tab
              label={`${t('resolveNoveltyModal.backgroundResearch.resultsByName')} (${backgroundResearchData.noveltiesByNameCount})`}
              {...tabProps(1)}
            />
          </Tabs>
          <TabPanel
            index={0}
            maxHeight="250px"
            value={selectedResultsTab}
          >
            {backgroundResearchData.noveltiesByDocumentNumberCount === 0 ? (
              <div style={{ padding: '20px', boxSizing: 'border-box', color: '#737373', lineHeight: '150%' }}>{t('resolveNoveltyModal.backgroundResearch.noResults')}</div>
            ) : (
              <div
                style={{ flexDirection: 'column' }}
                className="identification-document-container"
              >
                <div
                  className="subtitle"
                  style={{ color: '#F59E0B', lineHeight: '150%' }}
                >
                  {t('resolveNoveltyModal.backgroundResearch.detailsTitle')}
                </div>
                {backgroundResearchData.backgroundResearhNoveltiesByDocumentNumber.map((backgroundResearhNovelty: any, index: number) => {
                  return (
                    <div
                      key={index}
                      style={{ padding: '15px', boxSizing: 'border-box', borderBottom: '1px dashed #CCC' }}
                      className="identification-document-beneficiary-container"
                    >
                      {backgroundResearhNovelty.nombres && (
                        <div className="identification-document-row-item">
                          <div
                            className="subtitle"
                            style={{ textAlign: 'start' }}
                          >
                            <span>{t('resolveNoveltyModal.backgroundResearch.fullNameFound')}</span>
                            <div>{backgroundResearhNovelty.nombres}</div>
                          </div>
                        </div>
                      )}
                      <div className="identification-document-row-item">
                        {backgroundResearhNovelty.codigoLista && (
                          <div className="left-content">
                            <span>{t('resolveNoveltyModal.backgroundResearch.listCode')}</span>
                            <div>{backgroundResearhNovelty.codigoLista}</div>
                          </div>
                        )}
                        {backgroundResearhNovelty.link && (
                          <div className="right-content">
                            <span>{t('resolveNoveltyModal.backgroundResearch.linkToVerify')}</span>
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={backgroundResearhNovelty.link}
                            >
                              {backgroundResearhNovelty.link}
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  )
                })}
              </div>
            )}
          </TabPanel>
          <TabPanel
            index={1}
            maxHeight="250px"
            value={selectedResultsTab}
          >
            {backgroundResearchData.noveltiesByNameCount === 0 ? (
              <div style={{ padding: '20px', boxSizing: 'border-box', color: '#737373', lineHeight: '150%' }}>{t('resolveNoveltyModal.backgroundResearch.noResults')}</div>
            ) : (
              <div
                style={{ flexDirection: 'column' }}
                className="identification-document-container"
              >
                <div
                  className="subtitle"
                  style={{ color: '#F59E0B', lineHeight: '150%' }}
                >
                  {t('resolveNoveltyModal.backgroundResearch.detailsTitle')}
                </div>
                {backgroundResearchData.backgroundResearhNoveltiesByName.map((backgroundResearhNovelty: any, index: number) => {
                  return (
                    <div
                      key={index}
                      style={{ padding: '15px', boxSizing: 'border-box', borderBottom: '1px dashed #CCC' }}
                      className="identification-document-beneficiary-container"
                    >
                      {backgroundResearhNovelty.nombres && (
                        <div className="identification-document-row-item">
                          <div
                            className="subtitle"
                            style={{ textAlign: 'start' }}
                          >
                            <span>{t('resolveNoveltyModal.backgroundResearch.fullNameFound')}</span>
                            <div>{backgroundResearhNovelty.nombres}</div>
                          </div>
                        </div>
                      )}
                      <div className="identification-document-row-item">
                        {backgroundResearhNovelty.codigoLista && (
                          <div className="left-content">
                            <span>{t('resolveNoveltyModal.backgroundResearch.listCode')}</span>
                            <div>{backgroundResearhNovelty.codigoLista}</div>
                          </div>
                        )}
                        {backgroundResearhNovelty.link && (
                          <div className="right-content">
                            <span>{t('resolveNoveltyModal.backgroundResearch.linkToVerify')}</span>
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={backgroundResearhNovelty.link}
                            >
                              {backgroundResearhNovelty.link}
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  )
                })}
              </div>
            )}
          </TabPanel>
        </div>
      </div>
    </div>
  )
}
